
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {instrumentApi} from "@/api/instrument";
    import {dictApi, fileApi, manufactoryApi} from "@/api/organization";
    import axios from 'axios'
    import {inspectionOrderApi} from "@/api/inspection";
    import InstrumentList from "@/components/InstrumentList.vue";
    import {auditApi} from "@/api/audit";
    import reasons from "@/components/Reasons.vue";
    import {utils, write} from "xlsx";
    import FileSaver from "file-saver";
    import html2Canvas from "html2canvas";
    import JsPDF from "jspdf";
    import baseUrl from "@/constants";

    @Component({
        name: "technicalDetail",
        components: {InstrumentList, reasons}
    })
    export default class Home extends Vue {
        title = "器具检定";
        id = "0";   //id
        orderId = "0"; //orderId
        pageType = "0";  //0编辑  1查看
        listData = {} as any;  //详情返回数据
        private closePage: any;
        private exportReport: any;
        acceptanceOrderfailDialog = false;  //不通过原因
        checkDataArr = [];  //当前勾选的器具
        allSelected = [];
        checkMethod = 0;

        created() {
            this.init()
        }
        init(){
            this.id = this.$route.params.id;
            this.orderId = this.$route.params.orderId;
            this.pageType = this.$route.params.type;
            this.getDetail();
        }
        //获取器具详情
        getDetail(){
            inspectionOrderApi.listDetails({orderId:this.orderId, orderApplyId: this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    //已经受理完成的器具数量
                    const finishCount =  rData.instruments.filter((e: any) => {
                        return  [1, 3, 7, 8].indexOf(e.checkResult.value) > -1;
                    }).length;
                    //如果器具都已经受理完成了 则返回上一页
                    if(this.pageType == "0" && rData.instruments.length == finishCount){
                        //全部办理完成
                        this.$message.success("全部办理完成");
                        this.closePage();
                    }
                    this.checkMethod = rData.checkMethod;
                    try {
                        const jsonContent = JSON.parse(rData.jsonContent);
                        if(jsonContent && jsonContent['prove']){
                            rData.proveFileUrl = jsonContent['prove'];
                        }
                    }catch (e) {
                        console.log(e);
                    }


                    this.listData = rData;
                }
            })
        }
        handleClick(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
        }
        downBtn(){
            this.$message.error("下载档案，暂未实现");
        }
        inputBtn(){
            this.$message.error("导入检定结果，暂未实现");
        }
        // @Watch("$route.path")
        // get$routePath(){
        //     this.init();
        // }

        //获取器具的勾选  0查看  1受理  2不受理
        instrumentCheck(type: number){
            const dataArr = JSON.parse(JSON.stringify(this.allSelected));
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
            }
            if(type == 0){
                if (dataArr.length > 1 ) {
                    this.$message.error("只能勾选一条");
                    return;
                }
                this.evaluate(dataArr[0]);
            }else if(type == 1){
                const params = {
                    orderInstrumentsIds: dataArr.flatMap((e:any)=>e.id).join(","),
                    checkResult: "",
                    status: 8,
                    orderId: this.orderId,
                    orderApplyId: this.id
                }
                inspectionOrderApi.acceptanceOrNot(params).then(r => {
                    if (r.data.result == 0) {
                        this.$message.success("受理成功");
                        this.handleClick();
                        this.getDetail();
                    }
                })
            }else if(type == 2){
                this.checkDataArr = dataArr;
                this.acceptanceOrderfailDialog = true;
            }
        }
        //不受理确定
        inadmissibleBtn(){
            let reasons = this.$refs.reasons as HTMLFormElement;
            const reason = reasons.getText();
            if(reason == ""){
                this.$message.error("不受理原因必填");
                return
            }
            const params = {
                orderInstrumentsIds: this.checkDataArr.flatMap((e:any)=>e.id).join(","),
                checkResult: reason,
                status: 3,
                orderId: this.orderId,
                orderApplyId: this.id
            }
            inspectionOrderApi.acceptanceOrNot(params).then(r => {
                if (r.data.result == 0) {
                    this.$message.success("不受理成功");
                    this.handleClick();
                    this.getDetail();
                    this.acceptanceOrderfailDialog = false;
                }
            })
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        //检定受理判断
        checkboxInitEvaluate(row: any,index: number){
            if(this.pageType=="1"){
                //查看模式
                return 1;
            }
            if(row.checkResult){
                if ([1,3,7,8].indexOf(row.checkResult.value) > -1)
                    return 0;//0不可勾选
                else
                    return 1;//1可勾选
            }else{
                return 1;//1可勾选
            }
        }
        //进详情
        evaluate(data: any){
            let orderId = this.orderId;
            if(this.pageType == "1"){
                //查看模式控制详情中的受理按钮是否展示
                orderId = "";
            }
            this.$router.push("/qj/instrument/detail/2/" + data.instrumentId + "?result=3&orderInstrumentsId="+data.id+"&submitForm=0&orderId="+orderId+"&checkResult="+data.checkResult.value+"&orderApplyId="+this.id);
        }
        downFileV2(){
            window.open(baseUrl + "/file/download?file=" + this.listData.proveFileUrl + "&name=器具证明材料", '_blank');
        }
        //导出页面
        downFile() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                const pdfDom = this.$refs.pdfDom as HTMLFormElement;
                this.exportReport(pdfDom, "强检计量器具检定申请表", () => {
                    loading.close();
                });
            }, 1000);
        }
    }
